<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
      id="createAddBlackListDialog"
      :title="$t('text.blackRiskControlParameterSettings')"
      :visible="isShowBlackListRiskConfigDialog"
      v-model="isShowBlackListRiskConfigDialog"
      width="800px"
      @open="openDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
  >
    <el-form
        ref="form"
        :model="form"
        label-width="280px"
        v-show="submitted === false"
    >
      <el-form-item
          :label="$t('text.dailyMinutes')"
      >
        <el-input
            v-model="form.BLACKLIST_RISK_MINUTES_MAX_COUNT.config.minutes"
            auto-complete="off"
            style="width: 350px"
            :placeholder="$t('message.inputWalletOrCardNumber')"
        />

      </el-form-item>
      <el-form-item
          :label="$t('text.accumulateGreaterThanTransactions')"
      >
        <el-input
            v-model="form.BLACKLIST_RISK_MINUTES_MAX_COUNT.config.count"
            auto-complete="off"
            style="width: 350px"
            :placeholder="$t('message.inputWalletOrCardNumber')"
        />
      </el-form-item>

      <el-form-item
          :label="$t('text.switch')"
      >
        <el-switch
            v-model="form.BLACKLIST_RISK_MINUTES_MAX_COUNT.enabled"
            :active-text="$t('creditFlag.01')"
            :inactive-text="$t('creditFlag.00')">
        </el-switch>
      </el-form-item>

      <hr>
      <br>

      <el-form-item
          :label="$t('text.dailyAccumulatedAmountGreaterThanPKR')"
      >
        <el-input
            v-model="form.BLACKLIST_RISK_DAILY_AMOUNT.config.amount"
            auto-complete="off"
            style="width: 350px"
            :placeholder="$t('message.inputWalletOrCardNumber')"
        />
      </el-form-item>

      <el-form-item
          :label="$t('text.switch')"
      >
        <el-switch
            v-model="form.BLACKLIST_RISK_DAILY_AMOUNT.enabled"
            :active-text="$t('creditFlag.01')"
            :inactive-text="$t('creditFlag.00')">
        </el-switch>
      </el-form-item>

      <hr>
      <br>
      <el-form-item
          :label="$t('text.dailyAccumulatedTransactionsGreaterThan')"
      >
        <el-input
            v-model="form.BLACKLIST_RISK_DAILY_COUNT.config.count"
            auto-complete="off"
            style="width: 350px"
            :placeholder="$t('message.inputWalletOrCardNumber')"
        />
      </el-form-item>

      <el-form-item
          :label="$t('text.switch')"
      >
        <el-switch
            v-model="form.BLACKLIST_RISK_DAILY_COUNT.enabled"
            :active-text="$t('creditFlag.01')"
            :inactive-text="$t('creditFlag.00')">
        </el-switch>
      </el-form-item>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" v-if="submitted === false">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="submitted === false">{{
          $t('text.confirm')
        }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowBlackListRiskConfigDialog: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      form: {
        BLACKLIST_RISK_MINUTES_MAX_COUNT: {
          configName: "",
          config: {
            minutes: "",
            count: "",
          },
          enabled: "",
          id: "",
          remark: ""
        },
        BLACKLIST_RISK_DAILY_AMOUNT: {
          configName: "",
          config: {
            amount: "",
          },
          enabled: "",
          id: "",
          remark: ""
        },
        BLACKLIST_RISK_DAILY_COUNT: {
          configName: "",
          config: {
            count: "",
          },
          enabled: "",
          id: "",
          remark: ""
        },
      },
      rules: {
        amount: [
          {pattern: /^[0-9]+$/, message: this.$t('message.numericError'), trigger: ['blur', 'change']}
        ],
        count: [
          {pattern: /^[0-9]+$/, message: this.$t('message.numericError'), trigger: ['blur', 'change']}
        ],
      },
      loading: null,
      title: "",
      list: "",
      submitted: false,
      result: {
        success: false,
        message: "",
        link: ""
      },
    };
  },
  watch: {
    isShowBlackListRiskConfigDialog(newVal) {
      if (newVal) {
        this.fetchConfigData();
      }
    },
  },
  methods: {
    unlockDialog() {
      if (this.loading !== null) {
        this.loading.close();
      }
    },
    openDialog() {
      this.title = this.$t('text.testOrder');
      this.submitted = false;
      this.result = {
        success: false,
        message: "",
        link: ""
      };
    },
    closeDialog() {
      this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT = {
        configName: "",
        config: {
          minutes: "",
          count: "",
        },
        enabled: "",
        id: "",
        remark: ""
      };
      this.form.BLACKLIST_RISK_DAILY_AMOUNT = {
        configName: "",
        config: {
          amount: "",
        },
        enabled: "",
        id: "",
        remark: ""
      };
      this.form.BLACKLIST_RISK_DAILY_COUNT = {
        configName: "",
        config: {
          count: "",
        },
        enabled: "",
        id: "",
        remark: ""
      };
      this.$refs.form.resetFields();
      this.$emit("update:isShowBlackListRiskConfigDialog", false);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {

          const configs = [
            {
              id: this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.id,
              configName: this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.configName,
              remark: this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.remark,
              config: JSON.stringify({
                minutes: this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.config.minutes,
                count: this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.config.count,
              }),
              enabled: this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.enabled,
            },
            {
              id: this.form.BLACKLIST_RISK_DAILY_AMOUNT.id,
              configName: this.form.BLACKLIST_RISK_DAILY_AMOUNT.configName,
              remark: this.form.BLACKLIST_RISK_DAILY_AMOUNT.remark,
              config: JSON.stringify({
                amount: this.form.BLACKLIST_RISK_DAILY_AMOUNT.config.amount,
              }),
              enabled: this.form.BLACKLIST_RISK_DAILY_AMOUNT.enabled,
            },
            {
              id: this.form.BLACKLIST_RISK_DAILY_COUNT.id,
              configName: this.form.BLACKLIST_RISK_DAILY_COUNT.configName,
              remark: this.form.BLACKLIST_RISK_DAILY_COUNT.remark,
              config: JSON.stringify({
                count: this.form.BLACKLIST_RISK_DAILY_COUNT.config.count,
              }),
              enabled: this.form.BLACKLIST_RISK_DAILY_COUNT.enabled,
            },
          ];

          this.$axios
              .put('/config/updates', configs, {
                headers: { 'Content-Type': 'application/json' },
                transformRequest: [(data) => JSON.stringify(data)],
              })
              .then((res) => {
                this.unlockDialog();
                if (res.code === 200) {
                  this.$bus.$emit('refresh');
                  this.closeDialog();
                  this.$notify({
                    title: `${this.$t('text.success')}`,
                    message: res.msg,
                    type: 'success',
                  });
                  return true;
                } else {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                  });
                  return false;
                }
              })
              .catch(() => {
                this.unlockDialog();
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: this.$t('message.sysError'),
                });
              });
        } else {
          return false;
        }
      });
    },
    mounted() {
      this.openDialog();
    },
    fetchConfigData() {
      this.$axios
          .get('/config/black-risk', {params: {}})
          .then(res => {
            this.list = res.data;
            this.$emit("loaded", this.list);

            this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT = this.list.find(item => item.configName.includes("BLACKLIST_RISK_MINUTES_MAX_COUNT"));
            this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.config = JSON.parse(this.form.BLACKLIST_RISK_MINUTES_MAX_COUNT.config);

            this.form.BLACKLIST_RISK_DAILY_AMOUNT = this.list.find(item => item.configName.includes("BLACKLIST_RISK_DAILY_MAX_AMOUNT"));
            this.form.BLACKLIST_RISK_DAILY_AMOUNT.config = JSON.parse(this.form.BLACKLIST_RISK_DAILY_AMOUNT.config);

            this.form.BLACKLIST_RISK_DAILY_COUNT = this.list.find(item => item.configName.includes("BLACKLIST_RISK_DAILY_MAX_COUNT"));
            this.form.BLACKLIST_RISK_DAILY_COUNT.config = JSON.parse(this.form.BLACKLIST_RISK_DAILY_COUNT.config);
          });
    },
  },
};
</script>